import {
    add,
    addCircle,
    addCircleOutline,
    addOutline,
    airplaneOutline,
    attachOutline,
    banOutline,
    calendarOutline,
    call,
    callOutline,
    carOutline,
    cashOutline,
    chatbubbleEllipsesOutline,
    checkmarkOutline,
    chevronBack,
    chevronForward,
    close,
    closeCircle,
    constructOutline,
    createOutline,
    documentText,
    documentTextOutline,
    downloadOutline,
    ellipse,
    ellipseOutline,
    ellipsisHorizontalOutline,
    ellipsisVerticalOutline,
    eye,
    eyeOff,
    eyeOutline,
    fingerPrint,
    globeOutline,
    helpCircle,
    home,
    homeOutline,
    keyOutline,
    logOutOutline,
    mailOutline,
    notificationsOutline,
    personCircleOutline,
    personOutline,
    saveOutline,
    settingsOutline,
    time,
    timeOutline,
    trainOutline,
    trashOutline,
    walletOutline,
    wifi,
} from 'ionicons/icons';

export const IONIC_USED_ICONS = {
    add,
    addOutline,
    homeOutline,
    home,
    documentTextOutline,
    documentText,
    timeOutline,
    time,
    helpCircle,
    personCircleOutline,
    notificationsOutline,
    mailOutline,
    globeOutline,
    personOutline,
    settingsOutline,
    logOutOutline,
    eye,
    eyeOff,
    attachOutline,
    callOutline,
    call,
    downloadOutline,
    addCircleOutline,
    addCircle,
    calendarOutline,
    chevronForward,
    chevronBack,
    ellipseOutline,
    ellipse,
    airplaneOutline,
    chatbubbleEllipsesOutline,
    constructOutline,
    close,
    fingerPrint,
    cashOutline,
    createOutline,
    walletOutline,
    banOutline,
    wifi,
    closeCircle,
    trashOutline,
    saveOutline,
    carOutline,
    trainOutline,
    keyOutline,
    ellipsisHorizontalOutline,
    ellipsisVerticalOutline,
    eyeOutline,
    checkmarkOutline,
};
